








import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";

export default function Parallax() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "200%"]);

  return (
    <section id="skills">
    <div
      ref={ref}
      className="w-[120%] h-screen overflow-hidden relative grid place-items-center"
    >
      <motion.h1
        style={{ y: textY }}
        className="font-bold text-white text-2xl md:text-4xl relative z-10"
      >
        MY SKILLS
      </motion.h1>

     <div className="flex justify-evenly  text-3xl w-full leading-[40px]">
<div>
<h1><i class="fa-brands fa-codepen"> FRONTEND SKILLS</i></h1> <br />
<ul className="">
    <li>HTML</li>
    <li>CSS</li>
    <li>JAVASCRIPT</li>
    <li>REACT JS</li>
    <li>REDUX TOOLKIT</li>
    <li>TAILWIND CSS</li>
</ul>
</div>
<div>
<h1><i class="fa-brands fa-codepen"> 50% BACKEND SKILLS</i></h1> <br />
<ul className="">
    <li>NODE JS</li>
    <li>EXPRESS JS</li>
    <li>MONGODB</li>
</ul>
</div>
     </div>

      <motion.div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(/assets/stars.png)`,
          backgroundPosition: "bottom",
          backgroundSize: "cover",
          y: backgroundY,
        }}
      />
      <div
        className="absolute inset-0 z-30 bg-gradient-to-b from-transparent via-black/50 to-red"
        style={{
          mixBlendMode: 'multiply',
        }}
      />
    </div>
    </section>
  );
}
